export default "<button title=\"{{'BUTTONS.ADD' | translate}}\" class=\"btn btn-primary\" (click)=\"add()\">{{'BUTTONS.ADD' | translate}}</button>";